import { RequirementConditionOperator } from 'generated-graphql/types';

export const scoreConditionOptions = [
  {
    label: 'More than or equal to',
    value: RequirementConditionOperator.EqualToOrGreaterThan
  },
  {
    label: 'Lower than or equal to',
    value: RequirementConditionOperator.EqualToOrLowerThan
  },
  {
    label: 'Between or equal to',
    value: RequirementConditionOperator.Between
  }
];
